import { Button, CaretLeftIcon } from '@la/ds-ui-components';
import styles from './StepperDrawer.module.scss';

export type StepperDrawerProps = {
  addToCart?: boolean;
  currentNextAction?: string;
  form: Record<string, string>;
  handleNextClick: () => void;
  numberOfTotalSteps: number;
  onBackClick: () => void;
  onCancelButtonClick?: () => void;
  showBackButton?: boolean;
  stepNumber: number;
  type: 'submit' | 'button';
};

export const StepperDrawer = ({
  addToCart = false,
  currentNextAction,
  form,
  handleNextClick,
  numberOfTotalSteps,
  onBackClick,
  onCancelButtonClick,
  showBackButton = false,
  stepNumber,
  type,
}: StepperDrawerProps) => {
  const getActionMessage = () => {
    if (currentNextAction) {
      return currentNextAction;
    }

    if (stepNumber !== numberOfTotalSteps) {
      return 'Save and Continue';
    }

    if (addToCart) {
      return 'Checkout and Pay';
    }

    return 'Register now';
  };

  return (
    <div className={styles.bottomDrawer}>
      <div className={styles.drawerContent}>
        {onCancelButtonClick ? (
          <div className={styles.cancelButtonContainer}>
            <Button variant="text" size="xl" onClick={onCancelButtonClick}>
              Cancel
            </Button>
          </div>
        ) : null}
        <div className={styles.drawerInnerContainer}>
          {stepNumber !== 1 || showBackButton ? (
            <div className={styles.backButtonContainer}>
              <Button
                variant="outline"
                size="xl"
                leftIcon={<CaretLeftIcon />}
                onClick={onBackClick}
              >
                Back
              </Button>
            </div>
          ) : null}
          <div className={styles.forwardButtonContainer}>
            <Button
              size="xl"
              disabled={false}
              onClick={handleNextClick}
              type={type}
              {...form}
            >
              {getActionMessage()}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
